module.exports = __webpack_public_path__ + "static/media/XL.f54652d5.jpg";